import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MovieLaurel } from '@usheru-hff/shared/domain';
import { SharedUtilsImageModule } from '@usheru-hff/shared/utils-image';

@Component({
  selector: 'ush-ui-movie-laurel',
  standalone: true,
  imports: [CommonModule, SharedUtilsImageModule],
  templateUrl: './ui-movie-laurel.component.html',
  styleUrl: './ui-movie-laurel.component.scss'
})
export class UiMovieLaurelComponent {
  @Input({ required: true }) laurel!: MovieLaurel;

  leftLaurelSrc = 'https://cdnstatic.usheru.com/img/misc/left-laurel.png';
  rightLaurelSrc = 'https://cdnstatic.usheru.com/img/misc/right-laurel.png';
}
